import Cookie from "js-cookie";
import AppRoutePath from "../../router/AppRoutePath";
import httpclient from "../httpclient";

const Logout = async () => {
  let token = Cookie.get("firebase_token");
  let data = { token };

  let url = `${process.env.REACT_APP_BASE_API_URL}users/DeactivateUserPushNotif`;

  if (token) {
    httpclient
      .POST(url, data)
      .then((response) => {
        Cookie.remove("refresh_token");
        Cookie.remove("access_token");
        Cookie.remove("firebase_token");
        window.location.href = AppRoutePath.LOGIN;
      })
      .catch((error) => {
        if (error.response) {
          console.log("handleRomeveFirebaseToken", error.response);
        }
      });
  } else {
    Cookie.remove("refresh_token");
    Cookie.remove("access_token");

    window.location.href = AppRoutePath.LOGIN;
  }
};

export default Logout;
